export const SiteDashboardHumanImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="448"
      height="192"
      viewBox="0 0 448 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <g clipPath="url(#clip0_2711_73132)">
        <path d="M98.0825 192.151L98.058 166H72.5432V192.151" fill="#1D2B47" />
        <path d="M59.2002 192.049V166.181H84.715V192.049" fill="#B99BF9" />
        <path
          d="M59.2002 192.049V166.181H84.715V192.049H59.2002Z"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <circle
          cx="175.398"
          cy="44.3579"
          r="3.38947"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <circle
          cx="338.682"
          cy="136.611"
          r="3.38947"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <path d="M297.787 33.6001V40.8212V33.6001Z" fill="#1D2B47" />
        <path
          d="M297.787 33.6001V40.8212"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <path d="M294.177 37.2104H301.398H294.177Z" fill="#1D2B47" />
        <path
          d="M294.177 37.2104H301.398"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <path d="M160.735 113.474V120.695V113.474Z" fill="#1D2B47" />
        <path
          d="M160.735 113.474V120.695"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <path d="M157.124 117.084H164.345H157.124Z" fill="#1D2B47" />
        <path
          d="M157.124 117.084H164.345"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <path d="M89.7032 44.2103V51.4313V44.2103Z" fill="#1D2B47" />
        <path
          d="M89.7032 44.2103V51.4313"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <path d="M86.0928 47.8213H93.3138H86.0928Z" fill="#1D2B47" />
        <path
          d="M86.0928 47.8213H93.3138"
          stroke="#1D2B47"
          strokeWidth="0.791452"
        />
        <path
          d="M121.914 107.169L94.8461 101.783C93.2653 101.469 92.2301 99.9434 92.522 98.3583C92.7943 96.8756 94.1423 95.8379 95.6454 95.954L122.439 98.0104L121.914 107.169Z"
          fill="#EEC493"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M118.83 100.365L111.292 98.3564L107.662 97.3871L92.1725 93.258C90.6146 92.8416 89.6804 91.2509 90.0757 89.6875C90.4433 88.2262 91.8548 87.2781 93.3466 87.4905L119.952 91.2658L118.83 100.365Z"
          fill="#EEC493"
        />
        <path
          d="M110.168 98.0531L107.658 97.3826L92.1725 93.258C90.6146 92.8416 89.6804 91.2509 90.0757 89.6875C90.4433 88.2262 91.8548 87.2781 93.3466 87.4905L119.952 91.2658L118.835 100.375"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M118.38 93.7002L92.1347 85.1634C90.6009 84.6621 89.7552 83.021 90.237 81.481C90.6839 80.0422 92.1438 79.1719 93.6221 79.4631L119.989 84.6575L118.38 93.7002Z"
          fill="#EEC493"
        />
        <path
          d="M111.254 91.3804L92.1347 85.1634C90.6009 84.6621 89.7552 83.021 90.237 81.481C90.6839 80.0422 92.1438 79.1719 93.6221 79.4631L119.989 84.6575L118.387 93.6949"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M118.456 88.5523L97.7124 78.9207C96.249 78.2445 95.5838 76.5309 96.2079 75.0445C96.799 73.6394 98.353 72.9046 99.814 73.3394L120.01 79.3491L118.456 88.5523Z"
          fill="#EEC493"
        />
        <path
          d="M111.112 105.083L117.944 78.8169L122.495 79.9007C131.197 81.9705 139.164 86.3862 145.532 92.6677L149.071 96.1769L127.786 115.16C121.363 114.252 115.551 110.865 111.595 105.723L111.112 105.083Z"
          fill="#EEC493"
        />
        <path
          d="M114.159 86.556L97.713 78.9201C96.2495 78.2439 95.5843 76.5303 96.2084 75.0439C96.7995 73.6388 98.3535 72.904 99.8145 73.3388L122.791 80.0875C122.791 80.0875 140.598 85.1723 149.089 96.1806L185.406 119.383L165.187 144.301L127.786 115.16C121.363 114.252 115.551 110.865 111.595 105.723L111.107 105.086L114.373 92.0858"
          fill="#EEC493"
        />
        <path
          d="M114.159 86.556L97.713 78.9201C96.2495 78.2439 95.5843 76.5303 96.2084 75.0439C96.7995 73.6388 98.3535 72.904 99.8145 73.3388L122.791 80.0875C122.791 80.0875 140.598 85.1723 149.089 96.1806L185.406 119.383L165.187 144.301L127.786 115.16C121.363 114.252 115.551 110.865 111.595 105.723L111.107 105.086L114.373 92.0858"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M189.586 122.054L163.156 105.165L130.427 134.548L183.301 175.101"
          fill="white"
        />
        <path
          d="M189.586 122.054L163.156 105.165L130.427 134.548L183.301 175.101"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M134.36 120.275L143.288 127.231L163.155 105.165L153.513 99.0028"
          fill="#EEC493"
        />
        <path
          d="M134.36 120.275L143.288 127.231L163.155 105.165L153.513 99.0028"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M83.4128 89.427L114.177 83.6427C114.787 83.5279 115.404 83.8035 115.725 84.3342L122.101 94.915C122.359 95.3351 122.392 95.8557 122.19 96.3054L107.681 128.291C107.454 128.792 106.97 129.126 106.422 129.161C105.873 129.195 105.351 128.924 105.064 128.456L82.4232 91.6661C82.1672 91.2496 82.1324 90.7339 82.33 90.2867C82.5276 89.8396 82.9325 89.5181 83.4128 89.427Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.8"
        />
        <path
          d="M79.8688 83.3677L112.859 83.4482C113.37 83.4487 113.845 83.7113 114.117 84.1437C114.388 84.5761 114.419 85.1179 114.198 85.5783L99.824 115.248C99.5877 115.734 99.1066 116.053 98.5673 116.083C98.028 116.112 97.5153 115.846 97.228 115.389L78.6038 85.6372C78.3177 85.1788 78.3035 84.6011 78.5666 84.1292C78.8296 83.6572 79.3285 83.3655 79.8688 83.3677Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.8"
        />
        <path
          d="M127.381 88.3915L103.506 88.6487L103.417 90.3645C103.25 93.2606 105.416 95.7645 108.305 96.0172L116.283 96.7057C116.283 96.7057 117.396 104.696 123.443 107.54"
          fill="#EEC493"
        />
        <path
          d="M127.381 88.3915L103.506 88.6487L103.417 90.3645C103.25 93.2606 105.416 95.7645 108.305 96.0172L116.283 96.7058C116.283 96.7058 117.396 104.696 123.443 107.54"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M319.287 77.7424C281.745 83.6543 219.5 142.846 219.5 142.846L163.426 103.601L140.892 130.371C135.74 131.893 133.365 135.222 128 135.5C164.961 160.593 183.074 183.402 219.499 190.365C260.895 198.279 387.685 137.895 333.18 106.711C333.18 99.766 335.249 75.2287 319.287 77.7424Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M381.707 192.097H290.519L298.603 105.551C300.286 87.2702 315.632 73.2889 333.991 73.3094C351.717 73.3118 366.732 86.3741 369.188 103.929L381.707 192.097Z"
          fill="white"
        />
        <path
          d="M333.991 73.3094C351.717 73.3118 366.732 86.3741 369.188 103.929L381.707 193.023L290.519 192.56L297.896 110.818"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M292.056 175.673H379.234L374.698 143.246H295.086L292.056 175.673Z"
          fill="#B99BF9"
          stroke="#1D2B47"
          strokeWidth="0.8"
        />
        <path
          d="M387.263 135.163C385.029 117.951 383.316 102.71 375.227 87.4853C367.669 74.5263 352.474 79.1412 344.677 77.7647C332.385 109.937 346.777 128.881 346.777 128.881C336.748 130.719 317.809 139.769 304.507 138.34C304.94 170.523 305.884 185.463 312.488 190.365C318.389 214.2 346.646 212.275 359.192 203.076C371.624 193.961 388.578 178.732 387.263 135.163Z"
          fill="white"
        />
        <path
          d="M343.001 176.879L346.522 128.374L310.352 122.95C309.47 122.818 302.494 112.663 301.681 112.363L305.984 172.038C310.352 199.529 327.369 217.101 352.097 206.919C407.374 184.158 383.726 88.6797 370.129 81.5853"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M370.903 82.1679C364.025 77.8458 358.081 75.3661 353.191 74.1899V71.4958C353.191 69.9045 352.559 68.3784 351.433 67.2536C350.307 66.1289 348.78 65.4978 347.189 65.4993H321.87C320.28 65.4993 318.755 66.1311 317.63 67.2557C316.506 68.3802 315.874 69.9055 315.874 71.4958V79.636"
          fill="white"
        />
        <path
          d="M370.903 82.1679C364.025 77.8458 358.081 75.3661 353.191 74.1899V71.4958C353.191 69.9045 352.559 68.3784 351.433 67.2536C350.307 66.1289 348.78 65.4978 347.189 65.4993H321.87C320.28 65.4993 318.755 66.1311 317.63 67.2557C316.506 68.3802 315.874 69.9055 315.874 71.4958V79.636"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M181.693 116.295L159.462 144.539C154.595 149.582 147.426 149.016 141.511 144.848"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M305.021 16.0754L303.365 26.0842C302.554 30.9886 307.081 35.8189 313.477 36.8769L323.097 38.4682L326.881 27.5606L305.021 16.0754Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.8"
        />
        <circle
          cx="308.157"
          cy="17.5984"
          r="9.18306"
          transform="rotate(9.39261 308.157 17.5984)"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.8"
        />
        <path
          d="M347.725 45.3312L345.009 80.9212L321.314 85.3171L328.392 42.5325"
          fill="#EEC493"
        />
        <path
          d="M321.315 85.3176L328.392 42.5329"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M347.724 45.3318L345.008 80.9218"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M325.996 57.0167C325.996 57.0167 331.68 58.5442 336.371 56.525C334.145 62.8865 324.023 68.9404 324.023 68.9404L325.996 57.0167Z"
          fill="#1D2B47"
        />
        <circle
          cx="332.471"
          cy="43.0078"
          r="15.4345"
          transform="rotate(9.39261 332.471 43.0078)"
          fill="#EEC493"
        />
        <path
          d="M336.126 58.0054C330.043 59.4854 323.669 57.1445 319.99 52.0794C316.311 47.0143 316.055 40.2284 319.344 34.9013C322.632 29.5741 328.813 26.7609 334.989 27.7798"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M349.533 18.7052L342.428 17.5299C343.023 13.9068 341.015 10.3584 337.603 9.00185C334.192 7.64531 330.296 8.84639 328.24 11.8884C327.598 6.76536 323.279 2.89833 318.117 2.82356C312.954 2.74878 308.526 6.48911 307.735 11.5915L307.703 11.7858C306.157 21.1537 312.496 30.0021 321.863 31.5517L334.581 33.6555C332.036 41.9433 335.814 45.34 335.814 45.34C335.814 45.34 336.961 38.4064 340.622 37.82C344.284 37.2336 345.387 44.9445 340.055 46.0416C338.722 56.5148 346.816 57.8537 346.816 57.8537C354.104 54.1968 358.721 48.0076 361.647 41.7558C363.814 37.1259 363.69 31.7487 361.312 27.2235C358.934 22.6983 354.576 19.5463 349.533 18.7052Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.8"
        />
        <path
          d="M319.396 71.1715C319.396 71.1715 330.984 77.3824 348.678 70.0649C352.212 70.3256 351.916 83.2398 348.458 84.9316C344.999 86.6234 322.253 94.9142 320.514 90.2908C318.776 85.6674 319.396 71.1715 319.396 71.1715Z"
          fill="white"
        />
        <path
          d="M319.397 71.1715C319.397 71.1715 330.984 77.3824 348.678 70.0649"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M352.988 74.0914C352.988 74.0914 351.036 78.3904 342.832 79.9547"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M346.929 128.892L348.437 103.484L316.211 99.2914C315.538 99.2049 314.859 99.1715 314.181 99.1916L310.376 123.87C311.205 124.159 312.063 124.362 312.934 124.476L346.929 128.892Z"
          fill="#EEC493"
        />
        <path
          d="M316.207 99.2873L348.434 103.48L349.668 82.7169L316.96 81.1971L314.185 99.1962C314.86 99.1737 315.536 99.2041 316.207 99.2873Z"
          fill="#EEC493"
        />
        <path
          d="M301.976 110.245C301.204 116.199 304.706 121.881 310.372 123.865L314.173 99.1913C307.946 99.386 302.781 104.068 301.976 110.245Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M350.14 87.7294L346.961 128.779"
          stroke="#1A1C35"
          strokeWidth="0.8"
        />
        <path
          d="M361.777 79.7833L368.342 74.7449L370.589 57.2548C370.861 55.0477 370.031 52.8476 368.369 51.3699C366.707 49.8923 364.425 49.3259 362.265 49.8548L354.39 51.7148C350.096 52.728 346.152 54.8741 342.968 57.9296L320.094 88.0089L343.861 89.9843L345.805 89.7535C351.373 89.1004 356.468 86.3045 360.01 81.9584L361.777 79.7833Z"
          fill="#EEC493"
        />
        <path
          d="M342.187 83.0018C346.466 73.2802 341.299 63.9581 341.299 63.9581L349.734 64.1001C352.785 64.1539 355.325 61.7724 355.469 58.7244L355.553 56.9088L339.883 54.121C337.507 53.698 335.073 54.4601 333.362 56.163L328.825 60.4334C321.39 67.4294 316.014 76.7249 317.048 87.765H319.463L318.429 89.4918L333.238 98.0948"
          fill="#EEC493"
        />
        <path
          d="M343.812 90.0022C350.591 89.2121 353.551 87.8892 358.905 82.8553"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M368.764 71.9793L367.823 78.4027C366.918 81.1819 364.266 83.0125 361.347 82.8728L352.344 82.4511"
          fill="#EEC493"
        />
        <path
          d="M368.764 71.9793L367.823 78.4027C366.918 81.1819 364.266 83.0125 361.347 82.8728L352.344 82.4511"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M369.39 63.8828L368.671 71.5047C368.271 73.991 366.234 75.8886 363.726 76.1125L351.838 77.1734"
          fill="#EEC493"
        />
        <path
          d="M369.39 63.8828L368.671 71.5047C368.271 73.991 366.234 75.8886 363.726 76.1125L351.838 77.1734"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M369.43 63.9135C369.155 66.5288 367.257 68.6848 364.698 69.2892L351.589 72.3966C349.951 72.811 348.279 71.8561 347.803 70.2347C347.359 68.6988 344.172 63.5406 345.65 62.9235L364.929 56.8686C366.024 56.3045 367.339 56.3845 368.358 57.077C369.376 57.7695 369.934 58.9636 369.812 60.189L369.43 63.9135Z"
          fill="#EEC493"
        />
        <path
          d="M370.287 57.2548L369.43 63.9134C369.155 66.5288 367.257 68.6848 364.698 69.2892L351.589 72.3966"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M370.136 57.3173C369.853 59.9305 367.956 62.0831 365.4 62.693L352.295 65.8004C350.657 66.2179 348.982 65.2647 348.504 63.643C348.06 62.1071 350.355 59.0618 351.834 58.4448L362.265 55.4795L365.315 52.7361L370.136 57.3173Z"
          fill="#EEC493"
        />
        <path
          d="M370.136 57.3169C369.853 59.9302 367.956 62.0828 365.399 62.6927L352.295 65.8001"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M345.761 59.5541L362.532 55.1506"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M355.518 56.8862L339.848 54.0984C337.471 53.6754 335.038 54.4375 333.327 56.1404L328.79 60.4108C328.79 60.4108 319.428 67.3847 317.013 81.5321L314.261 101.39"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M346.755 129.274L310.549 124.104C309.666 123.978 302.618 113.872 301.804 113.578L299.049 133.575C299.048 139.859 303.64 145.2 309.853 146.14L345.281 151.479L346.755 129.274Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M127.506 135.259C130.115 137.606 134.651 137.607 137 135L143.5 127L132.83 119.847L127.037 126.281C125.908 127.533 125.323 129.183 125.411 130.867C125.499 132.551 126.252 134.131 127.506 135.259Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2711_73132">
          <rect width="448" height="192" rx="3.2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
